import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireRole } from '@/lib/auth/guards';

const CompanyDetailPage = lazy(() => import('./detail-page').then((m) => ({ default: m.CompanyDetailPage })));
const CompanyFormPage = lazy(() => import('./form-page').then((m) => ({ default: m.CompanyFormPage })));
const CompanyListPage = lazy(() => import('./list-page').then((m) => ({ default: m.CompanyListPage })));

export const companyRoutes: RouteObject[] = [
  {
    path: 'companies',
    handle: { crumb: 'Companies' },
    children: [
      { index: true, element: <CompanyListPage /> },
      {
        element: <RequireRole roles={['admin']} />,
        children: [
          { path: 'new', element: <CompanyFormPage />, handle: { crumb: 'New company' } },
          { path: ':id/edit', element: <CompanyFormPage />, handle: { crumb: 'Edit' } },
        ],
      },
      { path: ':id', element: <CompanyDetailPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'Company' } },
    ],
  },
];
